<template>
  <v-app>
    <v-main>
      <error-layout
        code="404"
        error="Page does not exist"
        message="Please, check that the URL is correct."
      ></error-layout>
    </v-main>
  </v-app>
</template>

<script>
import ErrorLayout from './layouts/ErrorLayout.vue';

export default {
  metaInfo: {
    title: '404 - Not Exists',
  },
  components: { ErrorLayout },
};
</script>
